// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"487b3793","462":"0f4e7c3d","467":"d81ee57c","488":"7a876c9d","687":"d6980408","739":"16a5e75a","826":"bc5623ab","848":"16b68813"}[chunkId] + ".chunk.js";
};